import { render, staticRenderFns } from "./CategoryChip.vue?vue&type=template&id=6f21e552&scoped=true"
import script from "./CategoryChip.vue?vue&type=script&lang=js"
export * from "./CategoryChip.vue?vue&type=script&lang=js"
import style0 from "./CategoryChip.vue?vue&type=style&index=0&id=6f21e552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21e552",
  null
  
)

export default component.exports